/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'project-actions.project-content.archive-error-title': 'Impossible de restaurer le projet',
  'project-actions.project-content.archive-project': 'Archiver le projet',
  'project-actions.project-content.archive-restore-error-description':
    "Les changements apportés au projet n'ont pas pu être enregistrés. Veuillez réessayer ultérieurement.",
  'project-actions.project-content.copy-link': 'Copier le lien',
  'project-actions.project-content.copy-project': 'Copier le projet',
  'project-actions.project-content.copy-project.cancel': 'Annuler',
  'project-actions.project-content.copy-project.close-modal': 'Fermer la fenêtre modale',
  'project-actions.project-content.copy-project.error':
    "Donnez un nom à votre projet pour que tout le monde sache de quoi il s'agit",
  'project-actions.project-content.copy-project.failed-description':
    'Une erreur est survenue lors du clonage du projet. Veuillez réessayer ultérieurement.',
  'project-actions.project-content.copy-project.failed-description-forbidden':
    "Vous n'êtes pas autorisé à copier ce projet.",
  'project-actions.project-content.copy-project.failed-title': 'Impossible de cloner ce projet.',
  'project-actions.project-content.copy-project.followers': 'Abonnés',
  'project-actions.project-content.copy-project.include': 'Inclure',
  'project-actions.project-content.copy-project.links': 'Liens',
  'project-actions.project-content.copy-project.project-name': 'Nom du projet',
  'project-actions.project-content.copy-project.submit': 'Envoyer',
  'project-actions.project-content.copy-project.success-description': 'Le projet a bien été cloné.',
  'project-actions.project-content.copy-project.success-link': 'Afficher le projet cloné.',
  'project-actions.project-content.copy-project.success-title': 'Projet {projectName} cloné.',
  'project-actions.project-content.copy-project.title': 'Copier le projet',
  'project-actions.project-content.follow': 'Suivre',
  'project-actions.project-content.follow-confirmation-description':
    'Tous les lundis matins, nous vous enverrons une synthèse contenant les mises à jour de tous les projets que vous suivez. Pourquoi les lundis ? <a>Découvrez-le ici.</a>',
  'project-actions.project-content.follow-confirmation-title': '🙌🏼 Vous suivez désormais ce projet !',
  'project-actions.project-content.follow-error-title': 'Impossible de suivre le projet',
  'project-actions.project-content.follow-unfollow-error-description':
    "Les changements apportés au projet n'ont pas pu être enregistrés. Veuillez réessayer ultérieurement.",
  'project-actions.project-content.restore-project': 'Restaurer le projet',
  'project-actions.project-content.share': 'Partager',
  'project-actions.project-content.unfollow': 'Ne plus suivre',
  'project-actions.project-content.unfollow-error-title': 'Impossible de ne plus suivre le projet',
};
